





























import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Emit, Inject, Prop } from 'vue-property-decorator'

import Modal from '@/components/molecules/Modal.vue'

@Component({
  components: {
    Modal,
  },
})
export default class SecurityCodeForm extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ default: '' })
  value: string

  showModalSecurityCode: boolean = false

  @Emit('input')
  onInput(_value: string): void {
    // Do nothing
  }
}
